import SigliveServiceV1 from 'Service/sigliveServiceV1';

const postPing = async (payload) => {
  const { data } = await SigliveServiceV1({
    method: 'POST',
    url: `/monitoring-operator/device/ping`,
    data: payload,
  });

  return data?.data;
};

export default postPing;
